<app-table-header
  (reload)="onRefreshList(false)"
  [loading]="loading"
  [withExportOption]="!!data.info.exportTableName"
  [withClearCache]="true"
  (exportBtnClicked)="exportBtnClicked()"
  (clearCache)="clearCache()"
  >
  <app-table-search-bar (search)="search($event)" [searchValue]="currentSearch"></app-table-search-bar>
</app-table-header>
<nz-table appColumnLayout
  #tableRef
  nzShowSizeChanger
  [nzScroll]="tableScroll"
  [nzVirtualItemSize]="useVirtualScroll ? virtualItemSize : 0"
  [nzVirtualMinBufferPx]="200"
  [nzVirtualMaxBufferPx]="400"
  [nzVirtualForTrackBy]="trackByArticle"
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  appKeepState
  id="articles-overview-list-table"
  >
  <thead>
    <tr>
      <th nzColumnKey="id" [nzSortFn]="true" nzWidth="75px">#ID</th>
      <th nzColumnKey="name" [nzSortFn]="true">Name</th>
      <th nzColumnKey="orderNumber" [nzSortFn]="true" nzWidth="140px">Bestellnummer</th>
      <th nzColumnKey="isBio" [nzSortFn]="true" nzAlign="center">Bio</th>
      <th nzColumnKey="isGiftbox" [nzSortFn]="true" nzAlign="center">Geschenkset</th>
      <th nzColumnKey="isNonPackable" [nzSortFn]="true" nzAlign="center">nicht verpackbar</th>
      <th nzColumnKey="isBagable" [nzSortFn]="true" nzAlign="center">verpackbar</th>
      <th nzColumnKey="needsGermanLabel" [nzSortFn]="true">deutsches Etikett nötig</th>
      <th nzColumnKey="isOwnProduction" [nzSortFn]="true" nzAlign="center">eigene Produktion</th>
      <th nzColumnKey="noWeightForProduction" [nzSortFn]="true" nzAlign="center">kein Gewicht für die Produktion</th>
      <th nzColumnKey="actions" nzRight nzWidth="70px"></th>
    </tr>
  </thead>
  <tbody>
    @if (useVirtualScroll) {
      <ng-template nz-virtual-scroll let-article>
        <tr>
          <td>{{article.id}}</td>
          <td>{{article.name}}</td>
          <td class="cell-nowrap">{{article.orderNumber}}</td>
          <td nzAlign="center"><app-boolean-icon [state]="article.isBio"></app-boolean-icon></td>
          <td nzAlign="center"><app-boolean-icon [state]="article.isGiftbox"></app-boolean-icon></td>
          <td nzAlign="center">
            <label
              nz-checkbox
              [(ngModel)]="article.isNonPackable"
              [disabled]="article.isBagable || article.isOwnProduction"
              (ngModelChange)="isNonPackableChange(article)"
            ></label>
          </td>
          <td nzAlign="center">
            <label
              nz-checkbox
              [(ngModel)]="article.isBagable"
              [disabled]="article.isNonPackable"
              (ngModelChange)="disableIsNonPackable(article)"
            ></label>
          </td>
          <td>
            <label
              nz-checkbox
              [(ngModel)]="article.needsGermanLabel"
              [disabled]="!article.isNonPackable"
              (ngModelChange)="needsGermanLabelChange(article, $event)"
            ></label>
          </td>
          <td nzAlign="center">
            <label
              nz-checkbox
              [(ngModel)]="article.isOwnProduction"
              [disabled]="article.isNonPackable"
              (ngModelChange)="disableIsNonPackable(article)"
            ></label>
          </td>
          <td nzAlign="center">
            <label
              nz-checkbox
              [(ngModel)]="article.noWeightForProduction"
              (ngModelChange)="updateArticleFlags(article)"
            ></label>
          </td>
          <td nzRight>
            <div class="actions">
              <app-icon-button
                icon="edit"
                [ariaLabel]="'Artikel bearbeiten: ' + article.name"
                (pressed)="openModal(article)"
              ></app-icon-button>
            </div>
          </td>
        </tr>
      </ng-template>
    } @else {
      @for (article of data.results; track article.id) {
        <tr>
          <td>{{article.id}}</td>
          <td>{{article.name}}</td>
          <td class="cell-nowrap">{{article.orderNumber}}</td>
          <td nzAlign="center"><app-boolean-icon [state]="article.isBio"></app-boolean-icon></td>
          <td nzAlign="center"><app-boolean-icon [state]="article.isGiftbox"></app-boolean-icon></td>
          <td nzAlign="center">
            <label
              nz-checkbox
              [(ngModel)]="article.isNonPackable"
              [disabled]="article.isBagable || article.isOwnProduction"
              (ngModelChange)="isNonPackableChange(article)"
            ></label>
          </td>
          <td nzAlign="center">
            <label
              nz-checkbox
              [(ngModel)]="article.isBagable"
              [disabled]="article.isNonPackable"
              (ngModelChange)="disableIsNonPackable(article)"
            ></label>
          </td>
          <td nzAlign="center">
            <label
              nz-checkbox
              [(ngModel)]="article.isOwnProduction"
              [disabled]="article.isNonPackable"
              (ngModelChange)="disableIsNonPackable(article)"
            ></label>
          </td>
          <td nzAlign="center">
            <label
              nz-checkbox
              [(ngModel)]="article.noWeightForProduction"
              (ngModelChange)="updateArticleFlags(article)"
            ></label>
          </td>
          <td nzRight>
            <div class="actions">
              <app-icon-button
                icon="edit"
                [ariaLabel]="'Artikel bearbeiten: ' + article.name"
                (pressed)="openModal(article)"
              ></app-icon-button>
            </div>
          </td>
        </tr>
      }
    }
  </tbody>
</nz-table>

<app-add-edit-article-modal (refresh)="onRefreshList(false)" #modal>
  <span trigger></span>
</app-add-edit-article-modal>

<app-export-table-modal #exportTableModalComponent></app-export-table-modal>
